export class PickupCorporateConfigEndpoint {
  public getConfig(): string {
    return "/horde/v1/pickup-corporate-config";
  }
}
